<section class="table-row">
  <div class="menu-title">
   <a (click)="navigateToEditMenu(menu?.id)">{{menu?.name}}</a>
  </div>
  <div class="menu-items row-item">
    <p [dsTooltip]="menuItems"  dsTooltipAlign="left" dsTooltipSize="small" dsTooltipColor="black">{{menuItems ? menuItems : '-'}}</p>
  </div>

  <div class="menu-actions table-actions row-item">
    <a [dsTooltip]="actionsRef" dsTooltipMode="click" dsTooltipAlign="right" dsTooltipSize="small">
      <i class="db-icon db-icon-ds-more-l"></i>
    </a>
  </div>
</section>

<ng-template #actionsRef>
  <div class="db-ai-builder-page-item__actions">
    <p (click)="onRemoveItem()">{{ 'text_removeMenu' | dbText }}</p>
  </div>
</ng-template>
